import { FormField, FormFieldNameEnum, FormFieldType } from "@/types/form";

export const loginFormFields: FormField[] = [
  { field: FormFieldNameEnum.Email, type: FormFieldType.Email },
  { field: FormFieldNameEnum.Password, type: FormFieldType.Password },
];
